import React from "react";
import { IonButton, useIonModal } from "@ionic/react";
import { Bot } from "../types/bot.type";
import CoinList from "./CoinList"; // Assuming you have this component
import getCoinImage from "../utils/getCoinImage";
import HelpButton from "./HelpButton";

interface CoinSelectorProps {
  bot: Bot;
  updateBot: (bot: Bot) => void;
}

const CoinSelector: React.FC<CoinSelectorProps> = ({ bot, updateBot }) => {
  const [presentCoinList, dismissCoinList] = useIonModal(CoinList, {
    onDismiss: async (whitelist?: string[]) => {
      if (whitelist && whitelist?.length > 0) {
        const uniqueWhitelist = Array.from(new Set(whitelist));
        const updatedBot = { ...bot, whitelist: uniqueWhitelist };
        delete updatedBot.data;
        updateBot(updatedBot);
      }
      dismissCoinList();
    },
    whitelist: bot.whitelist,
    selectionMode: true
  });

  return (
    <>
      <div className="mt-4 py-4 rounded-xl bg-primary-90 ">
        <div className="grid grid-cols-3 items-center px-5 gap-4">
          <p className="text-sm text-white col-span-2">Coins to Trade</p>
          <div className="flex justify-end items-center col-span-1 -m-3">
            <IonButton
              size="small"
              color="primary"
              onClick={() => presentCoinList()}
            >
              Edit
            </IonButton>
            <HelpButton id="coins_to_trade" />
          </div>
        </div>
        <div className="flex flex-wrap items-center p-4 px-6">
          {bot.whitelist.map((coin, index) => (
            <div key={index} className="mb-2 -ml-2">
              <img
                src={getCoinImage(coin)}
                alt={coin}
                className="w-[32px] h-[32px] rounded-full"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CoinSelector;
